'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dDefaultable$0024given$005f$002dDefaultable$005f$002dInt$0024 from "./dev.cheleb.scalamigen.-Defaultable$given_-Defaultable_-Int$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024 from "./dev.cheleb.scalamigen.-Form$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00248 from "./dev.cheleb.scalamigen.-Form$$anon$8.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_EitherSample$package$$anon$11() {
}
export { $c_Lsamples_EitherSample$package$$anon$11 as $c_Lsamples_EitherSample$package$$anon$11 };
$p = $c_Lsamples_EitherSample$package$$anon$11.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EitherSample$package$$anon$11;
/** @constructor */
function $h_Lsamples_EitherSample$package$$anon$11() {
}
export { $h_Lsamples_EitherSample$package$$anon$11 as $h_Lsamples_EitherSample$package$$anon$11 };
$h_Lsamples_EitherSample$package$$anon$11.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00248.$c_Ldev_cheleb_scalamigen_Form$$anon$8($j_dev$002echeleb$002escalamigen$002e$002dDefaultable$0024given$005f$002dDefaultable$005f$002dInt$0024.$m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fInt$(), $j_dev$002echeleb$002escalamigen$002e$002dForm$0024.$m_Ldev_cheleb_scalamigen_Form$().eU());
});
var $d_Lsamples_EitherSample$package$$anon$11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EitherSample$package$$anon$11, "samples.EitherSample$package$$anon$11", ({
  oK: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EitherSample$package$$anon$11 as $d_Lsamples_EitherSample$package$$anon$11 };
